export const countries = ["BE", "NL", "FR"];
export const languages = ["nl", "en"];
//# sourceMappingURL=index.js.map